import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import MagneticButton from "../components/MagneticButton";
import { TICKETS_URL } from "../data/reviews";

export default function ClosingCTA() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const yTitle = useTransform(scrollYProgress, [0, 1], ["12%", "-12%"]);

  return (
    <section
      ref={ref}
      data-testid="home-cta"
      className="section relative bg-[#050505] overflow-hidden border-t border-white/10"
    >
      <div className="px-6 md:px-14 lg:px-20 xl:px-24">
        <motion.h2
          style={{ y: yTitle }}
          className="font-display uppercase leading-[0.85] tracking-tight text-white"
        >
          <span className="block text-[16vw] md:text-[14vw]">Read the reviews.</span>
          <span className="block text-[16vw] md:text-[14vw] text-white/40">
            Best immersive theatre London.
          </span>
        </motion.h2>

        <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-6">
            <p className="text-white/70 text-lg md:text-2xl max-w-xl leading-relaxed">
              Every immersive theatre rave. Every 5★ immersive theatre review.
              Every outlet. Fourteen years of proof that COLAB is the best
              immersive theatre in London.
            </p>
          </div>
          <div className="md:col-span-6 flex flex-wrap items-center gap-4 md:justify-end">
            <MagneticButton href={TICKETS_URL} variant="velvet" testid="home-cta-book">
              Book tickets →
            </MagneticButton>
            <MagneticButton to="/reviews" variant="solid" testid="home-cta-reviews">
              Read every review
            </MagneticButton>
            <MagneticButton
              href="/api/press-kit.pdf"
              variant="ghost"
              testid="home-cta-press-kit"
            >
              Press kit (PDF)
            </MagneticButton>
          </div>
        </div>
      </div>
    </section>
  );
}
